import React from "react";

const StepIndicator = ({ currentStep }) => {
  const steps = [
    "Customer Selection",
    "Receiver List",
    "Payment Information",
    "Confirm Transaction",
    "Transaction Receipt",
  ];

  const stepCount = steps.length;
  const stepWidthPercentage = 100 / stepCount;

  // The center of the first circle is at (stepWidth / 2)
  // The center of the last circle is at 100 - (stepWidth / 2)
  const trackStart = stepWidthPercentage / 2;
  const trackTotalWidth = 100 - stepWidthPercentage;

  // Progress width is proportional to the completed gaps
  const progressWidth = ((currentStep - 1) / (stepCount - 1)) * trackTotalWidth;

  return (
    <div
      className="mb-5 mt-4 w-100 position-relative"
      style={{ minHeight: "60px" }}
    >
      {/* Track Background */}
      <div
        className="position-absolute"
        style={{
          height: "1px",
          background: "#eee",
          width: `${trackTotalWidth}%`,
          left: `${trackStart}%`,
          top: "12px",
          zIndex: 0,
        }}
      />
      {/* Bold Progress Line */}
      <div
        className="position-absolute"
        style={{
          height: "2px",
          background: "var(--primary)",
          width: `${progressWidth}%`,
          left: `${trackStart}%`,
          top: "12px",
          zIndex: 1,
          transition: "width 0.3s ease",
        }}
      />

      <div className="d-flex w-100">
        {steps.map((step, index) => {
          const stepNum = index + 1;
          const isCompleted = stepNum <= currentStep;

          return (
            <div
              key={index}
              className="d-flex flex-column align-items-center position-relative"
              style={{ zIndex: 2, width: `${stepWidthPercentage}%` }}
            >
              <div
                className="rounded-circle d-flex align-items-center justify-content-center fw-bold fs-12 mb-2"
                style={{
                  width: "24px",
                  height: "24px",
                  backgroundColor: isCompleted ? "var(--primary)" : "#f8f9fa",
                  color: isCompleted ? "#fff" : "#ccc",
                  border: isCompleted ? "none" : "1px solid #ccc",
                  transition: "all 0.3s ease",
                }}
              >
                {stepNum}
              </div>
              <span
                className="text-center"
                style={{
                  fontSize: "10px",
                  color: isCompleted ? "var(--primary)" : "#888",
                  fontWeight: isCompleted ? "bold" : "normal",
                  whiteSpace: "nowrap",
                  transition: "color 0.3s ease",
                }}
              >
                {step}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default StepIndicator;
